import { DateTime } from 'luxon';

import { MomentTimeFormats } from '../../../../../../helpers/Constants';

export interface IBroadcastScheduleValues {
  sendAtDate: DateTime | null;
  sendAtTime: Date | null;
}

export const emptyScheduleValues: IBroadcastScheduleValues = {
  sendAtDate: null,
  sendAtTime: null,
};

// THE DATE AND TIME EXACTLY AS PICKED, SENT WITHOUT ANY TIMEZONE CONVERSION
export const toSendAt = ({
  sendAtDate,
  sendAtTime,
}: IBroadcastScheduleValues) => {
  if (!sendAtDate || !sendAtTime) {
    return null;
  }

  return sendAtDate
    .set({
      hour: sendAtTime.getHours(),
      minute: sendAtTime.getMinutes(),
      second: 0,
      millisecond: 0,
    })
    .toFormat(MomentTimeFormats.fullDate);
};

export const hasSchedule = ({ sendAtDate, sendAtTime }: IBroadcastScheduleValues) =>
  !!(sendAtDate || sendAtTime);

// ONE HALF PICKED WITHOUT THE OTHER CANNOT BE SCHEDULED
export const hasIncompleteSchedule = (values: IBroadcastScheduleValues) =>
  hasSchedule(values) && !toSendAt(values);
